import _extends from 'babel-runtime/helpers/extends';
/** 客户管理路由 */
import Layout from '@/views/layout/CrmLayout';

var layout = function layout() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    path: '/crm',
    component: Layout,
    meta: _extends({
      requiresAuth: true
    }, meta)
  };
};

export default [_extends({}, layout({
  permissions: ['crm']
}), {
  children: [{
    path: 'workbench', // 仪表盘
    component: function component() {
      return import('@/views/crm/workbench');
    },
    meta: {
      title: '仪表盘',
      icon: 'board'
    }
  }]
}), _extends({}, layout({
  permissions: ['crm']
}), {
  children: [{
    path: 'message', // 待办事项
    component: function component() {
      return import('@/views/crm/message');
    },
    meta: {
      title: '待办事项',
      icon: 'message',
      num: 0
    }
  }]
}), _extends({}, layout({
  permissions: ['crm', 'leads']
}), {
  children: [{
    path: 'leads', // 线索列表
    component: function component() {
      return import('@/views/crm/leads/AllIndex');
    },
    meta: {
      title: '线索',
      icon: 'leads'
    }
  }]
}), _extends({}, layout({
  // permissions: ['crm', 'customer']
  permissionList: [['crm', 'customer'], ['crm', 'pool'], ['crm', 'customer', 'nearbyCustomer']]
}), {
  children: [{
    path: 'customer', // 客户列表
    component: function component() {
      return import('@/views/crm/customer/AllIndex');
    },
    meta: {
      title: '客户',
      icon: 'customer'
    }
  }]
}), _extends({}, layout({
  permissions: ['crm', 'contacts']
}), {
  children: [{
    path: 'contacts', // 联系人
    component: function component() {
      return import('@/views/crm/contacts/index');
    },
    meta: {
      title: '联系人',
      icon: 'contacts'
    }
  }]
}), _extends({}, layout({
  permissions: ['crm', 'business']
}), {
  children: [{
    path: 'business', // 商机列表
    component: function component() {
      return import('@/views/crm/business');
    },
    meta: {
      title: '商机',
      icon: 'business'
    }
  }]
}), _extends({}, layout({
  permissions: ['crm', 'contract']
}), {
  children: [{
    path: 'contract', // 合同列表
    component: function component() {
      return import('@/views/crm/contract');
    },
    meta: {
      title: '合同',
      icon: 'contract'
    }
  }]
}), _extends({}, layout({
  permissions: ['crm', 'receivables', 'index']
}), {
  children: [{
    path: 'receivables', // 回款列表
    component: function component() {
      return import('@/views/crm/receivables');
    },
    meta: {
      title: '回款',
      icon: 'receivables'
    }
  }]
}), {
  name: 'print',
  path: '/print', // 打印
  hidden: true,
  component: function component() {
    return import('@/views/crm/components/Print');
  },
  meta: {
    permissionList: [['crm', 'receivables', 'print'], ['crm', 'contract', 'print'], ['crm', 'business', 'print']],
    title: '打印',
    icon: 'print'
  }
}, _extends({}, layout({
  permissions: ['crm', 'invoice']
}), {
  children: [{
    path: 'invoice', // 发票列表
    component: function component() {
      return import('@/views/crm/invoice');
    },
    meta: {
      title: '发票',
      icon: 'invoice'
    }
  }]
}), _extends({}, layout({
  permissions: ['crm', 'visit']
}), {
  children: [{
    path: 'visit', // 回访列表
    component: function component() {
      return import('@/views/crm/visit');
    },
    meta: {
      title: '回访',
      icon: 'house'
    }
  }]
}), _extends({}, layout({
  permissions: ['crm', 'product']
}), {
  children: [{
    path: 'product', // 产品列表
    component: function component() {
      return import('@/views/crm/product');
    },
    meta: {
      title: '产品',
      icon: 'product'
    }
  }]
})];